export { default as Address } from './Address';
export { default as AmountPurpose } from './AmountPurpose';
export { default as ConfirmCoBorrower } from './ConfirmCoBorrower';
export { default as DOB } from './DOB';
export { default as Email } from './Email';
export { default as Income } from './Income';
export { default as IncomeAdditional } from './IncomeAdditional';
export { default as JAAgreement } from './JAAgreement';
export { default as Living } from './LivingStatus';
export { default as LoanType } from './LoanType';
export { default as Name } from './Name';
export { default as Password } from './Password';
export { default as Phone } from './Phone';
export { default as SSN } from './SSN';
export { default as AccountValidation } from './AccountValidation';
export { default as AddressCoBorrower } from './AddressCoBorrower';

require('/var/lib/jenkins/workspace/borrower-apply-ui_Release_0/src/pages/pi1-1QAAT/pi1-1QAAT.scss');